import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Switch,
  FormControlLabel,
} from "@mui/material";
import AddchartIcon from "@mui/icons-material/Addchart";
import styles from "./styles.module.css";
import GenericDatePicker from "../../../components/GenericDatePicker";
import { useEffect, useState } from "react";
import { editarPreviasInss } from "../../../services/api-inss.service";
import SnackBar from "../../../components/SnackBar";

const ModalEditar = ({
  open,
  onClose,
  dados,
  categorias,
  rechargeData,
  newPrevia,
}) => {
  const [dataForm, setDataForm] = useState({
    categoria: null,
    dtInicial: null,
    dtFinal: null,
    dtInicioEsocial: null,
    isCPRB: false,
  });
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });

  useEffect(() => {
    if (dados) {
      setDataForm({
        categoria: dados.categoria
          ? categorias.find((c) => c.id === dados.categoria)
          : null,
        dtInicial: new Date(dados.dtInicial),
        dtFinal: new Date(dados.dtFinal),
        dtInicioEsocial: dados.dtInicial ? dados.dtInicial : null, //  NULL ATÉ TER A INFORMAÇÃO
        isCPRB: dados.isCPRB ? dados.isCPRB : false, //  FALSE ATÉ TER A INFORMAÇÃO
      });
    }
  }, [dados]);

  const handleChangeDate = (value, type) => {
    setDataForm({ ...dataForm, [type]: value });
  };

  const handleChangeSwitch = (e) => {
    const { checked } = e.target;

    setDataForm({ ...dataForm, isCPRB: checked });
  };

  const handleSubmit = async () => {
    if (!dataForm.categoria) {
      setObjSnackBar({
        type: "error",
        msg: "Por favor, preeencha ao menos uma categoria.",
      });
      return;
    }
    if (!dataForm.dtInicial || !dataForm.dtFinal || !dataForm.dtInicioEsocial) {
      setObjSnackBar({
        type: "error",
        msg: "Dt. Inicial, Final e Início do E-Social são obrigatórias",
      });
      return;
    }
    try {
      await editarPreviasInss(dados.idPreviaInss, {
        ...dataForm,
        categoria: dataForm.categoria.id,
        status: "PREVIA-ANDAMENTO",
      });
      await rechargeData();
      setObjSnackBar({ type: "success", msg: "Prévia iniciada com sucesso!" });
      onClose();
    } catch (error) {
      setObjSnackBar({
        type: "error",
        msg: "Erro ao iniciar a prévia. Contate o suporte",
      });
      console.log(error);
    }
  };

  const sxControl = {
    transform: "scale(1)",
    "& .MuiSwitch-switchBase.Mui-checked": { color: "#18316E" },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#18316E",
    },
  };

  const sxFormControl = (margin) => {
    return {
      justifyContent: "flex-start",
      color: "#18316E",
      marginBottom: margin,
      marginLeft: "0rem",
      span: {
        fontSize: "0.8rem",
        fontWeight: 900,
        fontFamily: "Inter",
      },
    };
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>
          <div className={styles.title}>
            <AddchartIcon sx={{ marginRight: ".5rem" }} />{" "}
            {newPrevia ? "Iniciar Prévia" : "Editar prévia"}
          </div>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <Autocomplete
            value={dataForm.categoria}
            onChange={(_, value) => {
              setDataForm({ ...dataForm, categoria: value });
            }}
            options={categorias}
            getOptionLabel={(option) => option.label}
            fullWidth
            renderInput={(params) => (
              <TextField {...params} label="Categoria" />
            )}
          />
          <GenericDatePicker
            label="Data Inicial"
            value={dataForm.dtInicial}
            onChange={(value) => handleChangeDate(value, "dtInicial")}
          />
          <GenericDatePicker
            label="Data Final"
            value={dataForm.dtFinal}
            onChange={(value) => handleChangeDate(value, "dtFinal")}
          />
          <GenericDatePicker
            label="Data de Início do eSocial"
            value={dataForm.dtInicioEsocial}
            onChange={(value) => handleChangeDate(value, "dtInicioEsocial")}
          />
          <div style={{ width: "100%" }}>
            <FormControlLabel
              control={
                <Switch
                  sx={sxControl}
                  checked={dataForm.isCPRB}
                  onChange={(e) => handleChangeSwitch(e)}
                />
              }
              label="CPRB"
              sx={sxFormControl("0rem")}
              labelPlacement="start"
            />
          </div>
          <DialogActions className={styles.containerBtn}>
            <Button
              onClick={onClose}
              variant="contained"
              className={styles.btnCancelar}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              className={styles.btnSalvar}
              onClick={handleSubmit}
            >
              Salvar
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={setObjSnackBar} />
    </>
  );
};

export default ModalEditar;
